import React, { useState, useEffect, } from "react";
import { useHistory } from "react-router";
import { Button, Table } from "antd";
import { goPage } from "../../layout/pageDefinition";
import { useModel, useModelDispatchers } from "../../../models";
import moment from "moment";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '序号',
        width: 50,
        render: (text, record, index) => `${index + 1}`,
    },
    {
        title: '采购单号',
        width: 160,
        dataIndex: 'purchaseCode',
        align: 'left',
        render: (text, record, index) => { return record.isReplenish ? (<span className="color-red">{text}</span>) : text },
    },
    {
        title: '采购类型',
        width: 100,
        dataIndex: 'orderTypeName',
    },
    {
        title: '状态',
        width: 80,
        dataIndex: 'orderStatusName',
    },
    {
        title: '支付状态',
        width: 80,
        dataIndex: 'paymentStatusName',
    },
    {
        title: '供应商编码',
        width: 160,
        dataIndex: 'supplierCode',
    },
    {
        title: '供应商',
        width: 160,
        ellipsis: true,
        dataIndex: 'supplierName',
    },
    {
        title: '采购数量',
        width: 100,
        dataIndex: 'purchaseNum',
    },
    {
        title: '应付金额',
        width: 100,
        dataIndex: 'payableAmount',

    },
    {
        title: '已付金额',
        width: 100,
        dataIndex: 'paidAmount',

    },
    {
        title: '退货数量',
        width: 80,
        dataIndex: 'returnNum',
    },
    {
        title: '发票类型',
        width: 120,
        dataIndex: 'invoiceTypeName',
    },

    {
        title: '联系人',
        width: 120,
        dataIndex: 'supplierPerson',
    },
    {
        title: '电话',
        width: 120,
        dataIndex: 'supplierPhone',
    },
    {
        title: '业务员',
        width: 120,
        dataIndex: 'createUser',
    },
    {
        title: '库管',
        width: 120,
        dataIndex: 'warehouseMan',
    },
    /*{
        title: '公司',
        width: 160,
        ellipsis: true,
        dataIndex: 'orgName',
    },*/
    {
        title: '到货日期',
        width: 100,
        dataIndex: 'deliveryDate',
        render: text => text ? moment(text).format("YYYY-MM-DD") : ""
    },
    {
        title: '制单日期',
        width: 160,
        dataIndex: 'createTime',
        // render: text => text ? text.split(" ")[0] : ""
    },
    {
        title: '备注',
        width: 200,
        dataIndex: 'purchaseDesc',
    }
];


export default function () {
    const { getInvoiceTypeDict, getPayStatusDict, getPurchaseStatusDict, getPurchaseOrderTypeDict } = useModelDispatchers("cmDict");
    useEffect(() => {
        getInvoiceTypeDict();
        getPayStatusDict();
        getPurchaseStatusDict();
        getPurchaseOrderTypeDict();
    }, []);
    const [
        { searchParam, documentList, documentStatistic, documentPageInfo, selectedDocumentRowKeys },
        {
            loadDocumentList,
            setSelectedDocumentRowKeys,
            loadPo,
            setDocumentMaterialList,
            exportPo,
            setSelectedDocument,
            setFormData,
        }
    ] = useModel("purchasePo");

    useEffect(() => {
        const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
        const { pageSize, pageNum } = documentPageInfo;
        const { purchaseCode, supplierId, orderStatus, invoiceType } = searchParam;
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum,
            purchaseCode,
            supplierId,
            orderStatus,
            invoiceType
        }
        loadDocumentList({ showMsg: false, data });
    }, []);
    const TableHeader = () => {
        const history = useHistory();

        const onAdd = () => {
            setSelectedDocument({});
            setDocumentMaterialList([]);
            setFormData({});
            goPage(history, "2-3-2");
        }


        const onEdit = () => {
            setFormData({});
            loadPo({ showMsg: false, data: selectedDocumentRowKeys[0] }).then(() => {
                goPage(history, "2-3-1");
            })
        }

        const onExport = () => {
            const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
            const { purchaseCode, supplierId, orderStatus, invoiceType } = searchParam;
            let data = {
                startTime,
                endTime,
                purchaseCode,
                supplierId,
                orderStatus,
                invoiceType
            }
            exportPo({ showMsg: true, data })
        }

        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.P_AD}>
                        <Button type="primary" onClick={onAdd}>新增</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED}>
                        <Button
                            className="margin-left-8"
                            onClick={onEdit}
                            disabled={selectedDocumentRowKeys.length === 0}
                        >
                            {
                                (
                                    selectedDocumentRowKeys.length === 1
                                    && documentList.find(el => el.key === selectedDocumentRowKeys[0])
                                    && documentList.find(el => el.key === selectedDocumentRowKeys[0]).orderStatus === "025005"
                                ) ? "查看" : "编辑"
                            }
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic color-primary" style={{ textAlign: "right" }}>
                    <span
                        className="margin-left-8">
                        采购总量：{!!documentStatistic ? documentStatistic.purchaseQuantityTotal : 0}
                    </span>
                    <span
                        className="margin-left-16">
                        应付总金额：{!!documentStatistic ? documentStatistic.amountPayableTotal : 0.00}
                    </span>
                    <span
                        className="margin-left-16">
                        已付总金额：{!!documentStatistic ? documentStatistic.amountPaidTotal : 0.00}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={documentList}
                bordered
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: (pageNum, pageSize) => {
                        const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
                        const { purchaseCode, supplierId, orderStatus, invoiceType } = searchParam;
                        let data = {
                            startTime,
                            endTime,
                            pageSize,
                            pageNum,
                            purchaseCode,
                            supplierId,
                            orderStatus,
                            invoiceType
                        }
                        loadDocumentList({ showMsg: true, data });
                    },
                    total: documentPageInfo.total,
                    current: documentPageInfo.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedDocumentRowKeys.length > 0 && selectedDocumentRowKeys[0] === record.key) {
                                setSelectedDocumentRowKeys([]);
                            } else {
                                setSelectedDocumentRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys,) => {
                        setSelectedDocumentRowKeys(selectedRowKeys);
                    },
                    selectedRowKeys: selectedDocumentRowKeys
                }}
                scroll={{ x: 'max-content', y: 560 }}
            />
        </>
    );
}